import { useQuery } from '@tanstack/react-query';
import type { IntakeMethodOption, PropertyTypeOption } from '@munifocus/contracts-gov';
import { api } from './api-client';

/**
 * The Stage 1 pick-lists, which administrators control.
 *
 * These were compile-time unions in the contracts. The intake form now fetches
 * them, because both carry behaviour the officer's answers depend on — which
 * conditional section opens, and whether an entry authority is needed — and
 * that behaviour is per-row.
 *
 * Cached for the session: an officer filling in one intake form should not
 * re-fetch a list that changes a few times a year, and a stale label is
 * harmless next to the refetch chatter.
 */

const STALE_MS = 5 * 60 * 1000;

export const taxonomyKeys = {
  intakeMethods: ['taxonomies', 'intake-methods'] as const,
  propertyTypes: ['taxonomies', 'property-types'] as const,
};

export function useIntakeMethods() {
  return useQuery({
    queryKey: taxonomyKeys.intakeMethods,
    queryFn: async () => {
      const { data } = await api.get<IntakeMethodOption[]>('/taxonomies/intake-methods');
      return data;
    },
    staleTime: STALE_MS,
  });
}

export function usePropertyTypes() {
  return useQuery({
    queryKey: taxonomyKeys.propertyTypes,
    queryFn: async () => {
      const { data } = await api.get<PropertyTypeOption[]>('/taxonomies/property-types');
      return data;
    },
    staleTime: STALE_MS,
  });
}
